import CartProduct from './cart-product';

export default CartProduct;